import { cva } from '@/styled-system/css';

export const listRootRecipe = cva({
  base: {
    textStyle: 'body',
    color: 'List.label',
    paddingInlineStart: 'List.padding.nested-horz',
  },
  variants: {
    appearance: {
      bullet: {
        listStyleType: 'disc',
      },
      number: {
        listStyleType: 'decimal',
      },
      none: {
        'listStyleType': 'none',
        'paddingInlineStart': 'List.group-gap.default',
        '& ul': {
          paddingInlineStart: 'List.padding.nested-horz',
        },
      },
    },
  },
});
